import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var fileDownload = require("js-file-download");
import * as xlsx from "xlsx";
import moment from "moment";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import * as orderHandler from "@/js/order/order.js";
import { hasRole, isUserBuyerGroup } from "@/js/http/auth.js";
import { conciergerieTypesRequest } from "@/js/lists.ts";
import { wineNaming } from "@/js/wine/wine.js";
import TargetSelectors from "@/components/order/TargetSelector/TargetSelectors.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "ImportOrderDialog",
  props: {
    value: Boolean,
    loggedUserData: Object
  },
  components: {
    UploaderV2: function UploaderV2() {
      return import("@/components/default/UploaderV2.vue");
    },
    TargetSelectors: TargetSelectors,
    confirm: confirmationComponent
  },
  data: function data() {
    return {
      isConfiguring: true,
      isThirdPartyOrder: false,
      isUploading: false,
      isSyncFile: false,
      uploadKey: false,
      columns: [],
      items: [],
      itemStatus: {
        SUCCESS: {
          id: 1,
          class: "success",
          label: "fully imported"
        },
        WARNING: {
          id: 2,
          class: "warning",
          label: "partially imported"
        },
        ERROR: {
          id: 3,
          class: "danger",
          label: "not imported"
        }
      },
      orderId: null,
      thirdPartyUserKey: 0,
      pricePostingKey: null,
      form: {
        sku: "SKU",
        quantity: "NB BOTTLES ORDERED",
        valid: false
      },
      headers: [{
        text: "Line",
        value: "lineNumber",
        align: "center"
      }, {
        text: "",
        value: "status",
        align: "center"
      }, {
        text: "",
        value: "errorMessage",
        align: "center"
      }, {
        text: "SKU",
        value: "sku",
        align: "center"
      }, {
        text: "Description",
        value: "description",
        align: "center"
      }, {
        text: "Quantities initially ordered",
        value: "fileQuantity",
        align: "center"
      }, {
        text: "Quantities added to cart",
        value: "quantity",
        align: "center"
      }],
      result: {
        success: 0,
        warning: 0,
        danger: 0
      },
      rules: formRules
    };
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _orderHandler$getPric, _orderHandler$getPric2;
      var _orderHandler$getThir, _orderHandler$getThir2;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.isThirdPartyOrder = hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
            if (_this2.isThirdPartyOrder) {
              _this2.thirdPartyUserKey = (_orderHandler$getThir = (_orderHandler$getThir2 = orderHandler.getThirdPartyUserSelected()) === null || _orderHandler$getThir2 === void 0 ? void 0 : _orderHandler$getThir2.id_user) !== null && _orderHandler$getThir !== void 0 ? _orderHandler$getThir : 0;
            }
            _this2.pricePostingKey = (_orderHandler$getPric = (_orderHandler$getPric2 = orderHandler.getPricePostingUsaSelected()) === null || _orderHandler$getPric2 === void 0 ? void 0 : _orderHandler$getPric2.id) !== null && _orderHandler$getPric !== void 0 ? _orderHandler$getPric : null;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    shown: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit("input", value);
      }
    },
    isThirdPartyUserValid: function isThirdPartyUserValid() {
      return !this.isThirdPartyOrder || this.thirdPartyUserKey;
    },
    uploaderKey: function uploaderKey() {
      return this.thirdPartyUserKey + (this.pricePostingKey !== null ? "-".concat(this.pricePostingKey) : "");
    },
    uploadUrl: function uploadUrl() {
      var url = "".concat(process.env.VUE_APP_API_URL, "/v1/orders/import?sku=").concat(this.form.sku, "&quantity=").concat(this.form.quantity);
      var hasStartedQuerySupp = false;
      if (this.isThirdPartyOrder && this.thirdPartyUserKey) {
        url += "&thirdPartyUserId=".concat(this.thirdPartyUserKey);
        hasStartedQuerySupp = true;
      }
      url += (hasStartedQuerySupp ? "&" : "?") + "isApplyActivePricePostingByDefault=false";
      hasStartedQuerySupp = true;
      if (this.pricePostingKey !== null) {
        url += (hasStartedQuerySupp ? "&" : "?") + "pricePostingUsaProId=" + this.pricePostingKey;
        hasStartedQuerySupp = true;
      }
      return url;
    },
    thirdPartyContainerClass: function thirdPartyContainerClass() {
      var commonClasses = "mb-2";
      var disabledClass = this.isUploading ? " disabled-group" : "";
      return commonClasses + disabledClass;
    },
    itemsInError: function itemsInError() {
      var _this$items$filter$so,
        _this$items,
        _this3 = this;
      return (_this$items$filter$so = (_this$items = this.items) === null || _this$items === void 0 ? void 0 : _this$items.filter(function (x) {
        return [_this3.itemStatus.ERROR.id, _this3.itemStatus.WARNING.id].includes(x.status);
      }).sort(function (a, b) {
        return a.status > b.status;
      })) !== null && _this$items$filter$so !== void 0 ? _this$items$filter$so : [];
    }
  },
  methods: {
    changeThirdPartyUser: function changeThirdPartyUser() {
      var _orderHandler$getThir3, _orderHandler$getThir4;
      this.syncFiles(null);
      this.thirdPartyUserKey = (_orderHandler$getThir3 = (_orderHandler$getThir4 = orderHandler.getThirdPartyUserSelected()) === null || _orderHandler$getThir4 === void 0 ? void 0 : _orderHandler$getThir4.id_user) !== null && _orderHandler$getThir3 !== void 0 ? _orderHandler$getThir3 : 0;
    },
    changePricePosting: function changePricePosting() {
      var _orderHandler$getPric3, _orderHandler$getPric4;
      this.syncFiles(null);
      this.pricePostingKey = (_orderHandler$getPric3 = (_orderHandler$getPric4 = orderHandler.getPricePostingUsaSelected()) === null || _orderHandler$getPric4 === void 0 ? void 0 : _orderHandler$getPric4.id) !== null && _orderHandler$getPric3 !== void 0 ? _orderHandler$getPric3 : null;
    },
    routerLinkConciergerie: function routerLinkConciergerie(item) {
      return {
        name: "userConciergerie",
        query: {
          conciergerieType: conciergerieTypesRequest.find(function (x) {
            return x.text == "Specific product and/or vintage";
          }).contact_type,
          message: "I would like information about the availability of the following product " + wineNaming(this.$whitelabel, item.wine.naming_data, true, true)
        }
      };
    },
    exportWineList: function exportWineList() {
      return {
        name: "exportPriceList"
      };
    },
    close: function close() {
      var _this$$refs$uploader;
      (_this$$refs$uploader = this.$refs.uploader) === null || _this$$refs$uploader === void 0 || _this$$refs$uploader.cancelUpload();
      this.$emit("input", false);
    },
    restart: function restart() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this4$$refs$uploader, _currentOrder$items;
        var basket, currentOrder, _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.isConfiguring = true;
              _this4.isSyncFile = false;
              _this4.columns = [];
              _this4.items = [];
              _this4.result = {
                success: 0,
                warning: 0,
                danger: 0
              };

              //To manage cancel during a long import, some products can be added to a cart
              (_this4$$refs$uploader = _this4.$refs.uploader) === null || _this4$$refs$uploader === void 0 || _this4$$refs$uploader.resetFiles();
              if (_this4.orderId) {
                _context2.next = 11;
                break;
              }
              _context2.next = 9;
              return orderHandler.fetchBasket();
            case 9:
              basket = _context2.sent;
              orderHandler.setCurrentOrder(basket.data);
            case 11:
              currentOrder = orderHandler.getCurrentOrder();
              if (!((currentOrder === null || currentOrder === void 0 || (_currentOrder$items = currentOrder.items) === null || _currentOrder$items === void 0 ? void 0 : _currentOrder$items.length) > 0)) {
                _context2.next = 19;
                break;
              }
              _this = _this4;
              _context2.next = 16;
              return request("/v1/basket/".concat(currentOrder.id_order), "delete", {
                orderId: currentOrder.id_order
              }, true, "api").catch(function (e) {
                _this.$toasted.show("An error occurred when emptying the cart. Please contact an administrator.", {
                  type: "error"
                });
                throw e;
              });
            case 16:
              orderHandler.removeOrderFromStorage();
              _this4.$EventBus.$emit("BasketRemoved");
              _this4.orderId = null;
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    cancel: function cancel() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this5.restart();
            case 2:
              _this5.close();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    continueShopping: function continueShopping() {
      this.$EventBus.$emit("add-item-to-cart");
      var targetRouteName = isUserBuyerGroup(this.loggedUserData) ? "userProductList" : "adminProductList";
      if (this.$route.name === targetRouteName) {
        window.location.reload();
      } else {
        this.$router.push({
          name: targetRouteName
        });
      }
      this.close();
    },
    validateOrder: function validateOrder() {
      this.$router.push({
        name: "finalizeCart"
      });
    },
    submit: function submit() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _currentOrder$items2;
        var confirmed, currentOrder, valid;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              confirmed = true;
              currentOrder = orderHandler.getCurrentOrder();
              if (!(currentOrder && ((_currentOrder$items2 = currentOrder.items) === null || _currentOrder$items2 === void 0 ? void 0 : _currentOrder$items2.length) > 0)) {
                _context4.next = 6;
                break;
              }
              _context4.next = 5;
              return _this6.$refs.confirm.open("NEW IMPORT", "Are you sure you want to import the file? All items in the cart will be removed!", {
                color: "red"
              });
            case 5:
              confirmed = _context4.sent;
            case 6:
              if (confirmed && _this6.isThirdPartyUserValid) {
                valid = _this6.$refs.form.validate();
                if (valid) {
                  _this6.isUploading = true;
                  _this6.$refs.uploader.uploadAll();
                }
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    acknowledgeUpload: function acknowledgeUpload(response) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this, basket;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this = _this7;
              _this7.orderId = response.data.orderId;
              _this7.items = response.data.items.map(function (x) {
                var status = 0;
                var statusLabel = "";
                if (x.quantity == 0) {
                  status = _this.itemStatus.ERROR.id;
                  statusLabel = _this.itemStatus.ERROR.class;
                  _this.result.danger += 1;
                } else if (x.errorMessage) {
                  status = _this.itemStatus.WARNING.id;
                  statusLabel = _this.itemStatus.WARNING.class;
                  _this.result.warning += 1;
                } else {
                  status = _this.itemStatus.SUCCESS.id;
                  statusLabel = _this.itemStatus.SUCCESS.class;
                  _this.result.success += 1;
                }
                return _objectSpread(_objectSpread({}, x), {}, {
                  status: status,
                  statusLabel: statusLabel
                });
              });
              _this7.items.sort(function (a, b) {
                return b.status - a.status;
              });
              if (!_this7.orderId) {
                _context5.next = 10;
                break;
              }
              _context5.next = 7;
              return orderHandler.fetchBasket();
            case 7:
              basket = _context5.sent;
              orderHandler.setCurrentOrder(basket.data);
              _this7.$EventBus.$emit("update-cart");
            case 10:
              _this7.isConfiguring = false;
              _this7.isUploading = false;
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    syncFiles: function syncFiles(files) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var data, workbook, wbJson, sheetName;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(files !== null && files !== void 0 && files.length)) {
                _context6.next = 10;
                break;
              }
              _context6.next = 3;
              return files[0].arrayBuffer();
            case 3:
              data = _context6.sent;
              workbook = xlsx.read(data);
              wbJson = File.transformSheetToJson(workbook);
              sheetName = workbook.SheetNames[0];
              if (wbJson[sheetName]) {
                _this8.columns = wbJson[sheetName][0];
                _this8.isSyncFile = true;
              } else {
                _this8.columns = [];
                _this8.isSyncFile = false;
                _this8.$toasted.show("Invalid file, sheet ".concat(sheetName, "."), {
                  type: "error"
                });
              }
              _context6.next = 12;
              break;
            case 10:
              _this8.columns = [];
              _this8.isSyncFile = false;
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    uploadFailed: function uploadFailed() {
      this.isUploading = false;
    },
    downloadErrors: function downloadErrors() {
      var formattedDate = moment().format("YYYY-MM-DD");
      var fileName = "IMPORT_ORDER_ERRORS-".concat(formattedDate, ".xlsx");
      var data = this.itemsInError.map(function (item) {
        return {
          Line: item.lineNumber,
          Error: item.errorMessage,
          SKU: item.sku,
          Wine: item.description,
          "Quantities initially ordered": item.fileQuantity + " b.",
          "Quantities added to cart": item.quantity + " b."
        };
      });
      var worksheet = xlsx.utils.json_to_sheet(data);
      var workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Errors");
      var excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      var dataBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      fileDownload(dataBlob, fileName, "application/xlsx");
    },
    isUserBuyerGroup: isUserBuyerGroup
  }
};